export default [
  {
    path: "/",
    name: "default",
    meta: {
      title: "ana",
      authRequired: true,
      requiresParams: false,
    },
    component: () => import("@/views/AnaSayfa.vue"),
  },
  {
    path: "/ana-sayfa",
    name: "ana-sayfa",
    component: () => import("@/views/AnaSayfa.vue"),
    meta: {
      title: 'Ana Sayfa',
      authRequired: true,
      requiresParams: false
    }
  },
  {
    path: "/tokenreader",
    name: "tokenreader",
    component: () => import("../views/TokenReader.vue"),
    meta: {
      title: "TokenReader",
      authRequired: false,
      requiresParams: false
    }
  },
  {
    path: "/redirector",
    name: "redirector",
    component: () => import("../views/error/Redirector.vue"),
    meta: {
      title: "Redirector",
      authRequired: true,
      requiresParams: false
    }
  },
  {
    path: "",
    name: "route-page",
    component: () => import("../views/RoutePage.vue"),
    meta: {
      title:"Yönlendirme Sayfası",
      authRequired: true,
      requiresParams: false,
    },
  },
  {
    path: "",
    name: "error-403",
    component: () => import("../views/error/Error403.vue"),
    meta: {
      title:"403",
      requiresParams: false,
    },
  },
  {
    path: "/public/rehber",
    name: "rehber",
    component: () => import("@/views/Rehber/Rehber.vue"),
    meta: {
      title: 'Rehber',
      requiresParams: true,
      authRequired: false,
      layout: "full",
    },
  },
  {
    path: "/public/rehber-detail",
    name: "rehber-detail",
    component: () => import("@/views/Rehber/RehberDetail.vue"),
    meta: {
      title: 'Rehber',
      requiresParams: true,
      authRequired: false,
      layout: "full",
    },
  },
  {
    path: "/public/belge-viewer",
    name: "BelgeViewer",
    component: () => import("@/views/BelgeViewer/BelgeViewer.vue"),
    meta: {
      title: 'Belge Görüntüleyici',
      requiresParams: true,
      authRequired: false,
      layout: "full",
    },
  },
];
